<template>
  <span  v-html="svgContent" @click="onClick"/>
</template>

<script>
import {computed, getCurrentInstance} from 'vue';

export default {
  name: "Icon",
  props: {
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '',
    },
    size: {
      type: [String, Number],
      default: 6,
    },
    cClass: {
      type: String,
      default: '',
    },
  },
  inheritAttrs: false,
  setup(props, {emit}) {

    const colorClass = computed(() => (props.color ? `fill-${props.color}` : ''));
    const addClasses = computed(() => [props.cClass, colorClass.value].join(' '));

    const onClick = () => {
      emit('click')
    }
    const svgContent = computed(() => {
      try {
        const svg = getCurrentInstance().proxy.$icons[props.icon];
        const classes = `h-${props.size} w-${props.size} `;
        return svg.replace('<svg', `<svg fill="currentColor" class="${classes} ${addClasses.value}"`);
      } catch (er) {
        console.error(er.stack, er);
        return '';
      }
    });

    return {
      props,
      colorClass,
      svgContent,
      addClasses,
      onClick
    };
  },
};
</script>
